import { Controller } from "@hotwired/stimulus";

export default class LoadingController extends Controller {
  static targets = ["button"];

  connect() {}

  start(event) {
    const button = event.currentTarget;
    button.disabled = true;
    button.setAttribute("disabled", "true");
    button.innerHTML = "Carregando ...";
  }

  stop(event) {
    const button = event.currentTarget;
    button.disabled = false;
    button.removeAttribute("true");
    button.innerHTML = "Aprovar";
  }
}
